var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web-web_browser-document-online_learning-home"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410,31.9c27.6,0,54.1,10.9,73.6,30.5L494.8,51C448,4.1,372,4.1,325.2,51l11.3,11.3 C355.9,42.8,382.4,31.8,410,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.2,73.6c-34.3-34.4-90-34.4-124.4,0c0,0,0,0,0,0L359.1,85c28.1-28.1,73.7-28.1,101.8,0L472.2,73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.6,96.3c-21.8-21.9-57.2-21.9-79.1-0.1c0,0-0.1,0.1-0.1,0.1l11.4,11.3c15.6-15.6,40.8-15.6,56.4,0 c0,0,0,0,0,0L449.6,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434,135.9c0-13.3-10.7-24-24-24s-24,10.7-24,24s10.7,24,24,24S434,149.1,434,135.9z M402,135.9 c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8S402,140.3,402,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386,191.9H114c-13.2,0-24,10.8-24,24v192c0,13.2,10.8,24,24,24h272c13.2,0,24-10.8,24-24v-192 C410,202.6,399.2,191.9,386,191.9z M354,415.9H146v-104c0-4.4,3.6-8,8-8h192c4.4,0,8,3.6,8,8V415.9z M394,407.9c0,4.4-3.6,8-8,8 h-16v-104c0-13.2-10.8-24-24-24H154c-13.2,0-24,10.8-24,24v104h-16c-4.4,0-8-3.6-8-8v-136h288V407.9z M394,255.9H106v-40 c0-4.4,3.6-8,8-8h272c4.4,0,8,3.6,8,8V255.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122,223.9h16v16h-16V223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154,223.9h16v16h-16V223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186,223.9h16v16h-16V223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362,223.9h16v16h-16V223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282,380.5l-18.3-18.3l-11.3,11.3l24,24c3.1,3.1,8.2,3.1,11.3,0l48-48l-11.3-11.3L282,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,319.9h16v16h-16V319.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194,319.9h40v16h-40V319.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,351.9h72v16h-72V351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,383.9h72v16h-72V383.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.4,201.2c2.2,0,4.5-0.3,6.6-1c6.5-1.8,11.8-6.3,14.8-12.3l1.7-3.3c5.5-11.2,1.5-24.8-9.1-31.3L454.1,137 l-8.2,13.8l27.3,16.3c3.5,2.2,4.9,6.7,3,10.5l-1.7,3.3c-1,2-2.7,3.5-4.9,4.1c-2.2,0.6-4.5,0.3-6.4-0.8l-25-15.1l-8.2,13.8l12,7.2 v257.9H58V189.9L245.8,76.8c2.6-1.5,5.8-1.5,8.3,0l47.7,28.7l8.3-13.7l-47.8-28.7c-7.6-4.6-17.2-4.6-24.8,0l-200.9,121 c-1.9,1.1-4.2,1.4-6.4,0.8c-2.1-0.6-3.9-2.1-4.9-4.1l-1.7-3.3c-1.8-3.8-0.5-8.3,3-10.5L245.9,35.6c2.5-1.4,5.6-1.4,8.2,0l47.8,28.7 l8.2-13.8l-47.8-28.6c-7.6-4.6-17.1-4.6-24.6,0L18.6,153.4c-10.7,6.5-14.6,20.1-9.1,31.3l1.7,3.3c3,6,8.3,10.5,14.8,12.3 c2.2,0.6,4.4,1,6.6,1c3.3-0.1,6.5-0.8,9.4-2.2v248.8h-8c-13.3,0-24,10.7-24,24s10.7,24,24,24h432c13.3,0,24-10.7,24-24 s-10.7-24-24-24h-8V199.1C461,200.4,464.2,201.1,467.4,201.2z M466,463.9c4.4,0,8,3.6,8,8s-3.6,8-8,8H34c-4.4,0-8-3.6-8-8 s3.6-8,8-8H466z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkTest);
export default __webpack_public_path__ + "static/media/Walk Test.e6452c4c5cb521a9f53f877b000f2c14.svg";
export { ForwardRef as ReactComponent };